export default __webpack_public_path__ + "static/media/flutter-3.a6e76de0.png";